import { jsx as _jsx } from "react/jsx-runtime";
import { SvgBan } from '../../index';
import { Alert, SIZE } from './Alert';
export { SIZE };
export const DangerAlert = (props) => {
    return _jsx(Alert, { type: 'danger', icon: _jsx(SvgBan, {}), ...props });
};
//# sourceMappingURL=DangerAlert.js.map